import QRCodeStyling, { type Options } from 'qr-code-styling'
import { useEffect, useRef } from 'react'

export const QRCode = ({ data, width = 180, height = 180, ...props }: Options) => {
  const ref = useRef<HTMLDivElement | null>(null)

  const qrCode = new QRCodeStyling({
    width,
    height,
    margin: 0,
    type: 'svg',
    dotsOptions: {
      color: '#000',
      type: 'dots',
    },
    cornersSquareOptions: {
      color: '#000',
      type: 'extra-rounded',
    },
    cornersDotOptions: {
      color: '#000',
      type: 'dot',
    },
    ...props,
  })

  useEffect(() => {
    if (ref.current) {
      qrCode.append(ref.current)
    }
  }, [])

  useEffect(() => {
    qrCode.update({
      data,
    })
  }, [data])

  return <div ref={ref} className="overflow-hidden rounded-xl" />
}
